import { LottieLoader } from "../components/loader";

const LogoutPublic = () => {

  return (
    <div>
      <LottieLoader />
    </div>
  );
};

export default LogoutPublic;
